import { Link, useLocation } from "react-router-dom";
import { PLATFORM_BRAND } from "../../config/platformBrand";
import LanguageSwitcher from "../LanguageSwitcher";
import YulqoMark from "./YulqoMark";
import styles from "./AppBar.module.css";

const AppBar: React.FC = () => {
  const { pathname } = useLocation();
  if (pathname.includes("/tv")) return null;

  return (
    <header className={styles.bar}>
      <Link to="/" className={styles.brand}>
        <YulqoMark size={38} title={PLATFORM_BRAND.productName} />
        <span>{PLATFORM_BRAND.productName.toLowerCase()}</span>
      </Link>
      <LanguageSwitcher />
    </header>
  );
};

export default AppBar;
